import React, { useState } from "react";
import { url } from "../settings";

// Dependencies

//Components

// Styles
import styled from "styled-components";
import { fontFamily } from "../Typography";
import { grayscale, blue } from "../Utilities";
import { fontWeight } from "../Cytoplasm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/pro-duotone-svg-icons";

export default function StatisticsTutorial(props) {
  const { user, dismissed } = props;

  function dismissNotification() {
    setVisible(false);
    return fetch(`${url}/rounds/dismiss-notification/`, {
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        userId: user.id,
        notification: "statistics_tutorial",
      }),
    }).then((response) => {
      return response;
    });
  }

  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  if (dismissed) return null;

  return (
    <TutorialContainer>
      <FontAwesomeIcon icon={faChartLine} size="6x" />
      <div className="big-text">Clinic Statistics</div>
      <p className="text">
        Each completed encounter is saved so that you can track your performance
        (correct vs. incorrect) over time.
      </p>
      <p className="text">
        <strong>Answer Carefuly!</strong> <br />
        Once an encounter is completed, it is counted towards your clinic
        statistics{" "}
        <span style={{ textDecoration: "underline" }}>only once</span>. This
        means that subsequent attempts/answers on completed encounters, will not
        add to, or change your clinic statistics.
      </p>
      <div className="confirm" onClick={() => dismissNotification()}>
        Dismiss
      </div>
    </TutorialContainer>
  );
}
const TutorialContainer = styled.div`
  padding: 25px;
  margin-top: 35px;
  background-color: ${grayscale.lightGray};
  text-align: center;
  .text {
    font-size: 18px;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
  }
  .big-text {
    font-size: 28px;
    font-weight: 700;
    margin-top: 20px;
  }
  .confirm {
    padding: 8px 10px;
    border-radius: 5px;
    background-color: ${grayscale.gray};
    color: ${blue.bright};
    max-width: fit-content;
    margin: auto;
    margin-top: 25px;
    cursor: pointer;
    font-weight: ${fontWeight.bold};
    &:hover {
      background-color: ${grayscale.gray};
    }
  }
`;
